import { ReactNode } from "react";

interface BadgeProps {
  variant: "success" | "danger";
  children: ReactNode;
}

const badgeVariants: Record<BadgeProps["variant"], string> = {
  success: "bg-[#EAFBF3] text-[#00A67F]",
  danger: "bg-[#FFEEEE] text-[#FF2D00]",
};

export function Badge({ variant, children }: BadgeProps) {
  return (
    <span
      className={`inline-flex shrink-0 items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-bold whitespace-nowrap ${badgeVariants[variant]}`}
    >
      {children}
    </span>
  );
}
